<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="profile.biography && profile.biography.length > 0">
      <div class="text-xs-center pt-4">
        <div class="headline">
          Biography
        </div>
      </div>

      <v-card-text class="text-xs-justify">
        <Markdown :html="false" :source="profile.biography" class="markdown" />
      </v-card-text>
    </v-flex>
  </v-layout>
</template>

<script>
// Component
import Markdown from 'vue-markdown'

export default {
  components: { Markdown },
  props: { profile: { type: Object, required: true } },
}
</script>
